import Grid from '@material-ui/core/Grid'
import DatePicker from 'Components/DatePicker'
import Input from 'Components/Input'
import ListingModal from 'Components/ListingModal'
import Multiple from 'Components/Multiple'
import Search from 'Components/Search'
import Select from 'Components/Select'
import { Emoji } from 'emoji-mart'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents/index'
import InputClient from 'EurestoComponents/InputClient'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'




const project = require('EurestoConfig/project.config')

class DatagridContact extends React.Component {

  render() {
    return <Search limit={50} all raz={true} defaultSearch={{
      ...(this.props.defaultSearch || {}),
      'sdd_classeur.visible': 1
    }} path={'sdd'} requete={'dossier'}
      search={this.props.search || 'dossier_' + (this.props.name || '') + User.Entite.get().id}>
      <SearchClient />
    </Search>
  }

}

class SearchClient extends React.Component {

  constructor(props) {
    super(props)

    const regroupement = Data.list(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur)
    const utilisateurs = Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, {
      civilite_id: {
        not: true,
        value: null
      },
      archive_id: null
    })

    let options = []

    regroupement.map(grp => {
      options.push({
        label: grp.libelle,
        value: grp.id,
        html: <strong>{grp.libelle}</strong>
      })
      options = options.concat((grp.utilisateurs || []).map(uid => ({
        label: (utilisateurs.find(u => u.id === uid) || {}).libelle,
        html: <span style={{ paddingLeft: 5 }}>{(utilisateurs.find(u => u.id === uid) || {}).libelle}</span>,
        value: uid
      })))
    })
    if ((utilisateurs || []).length > 0) {
      options.push({
        label: 'Utilisateurs',
        html: <Grid container onClick={e => e.stopPropagation()}
          style={{ cursor: 'not-allowed', width: '100%', margin: 0, padding: 0 }} justify={'center'}
          alignItems={'center'}><strong>Utilisateurs</strong></Grid>,
        value: undefined
      })
    }
    const UtilisateurOptions = utilisateurs.map(user => ({
      label: user.libelle,
      value: user.id
    }))

    options = options.concat((UtilisateurOptions || []))

    this.state = {
      search: props.search,
      key: Utils.getRandomNumber(),
      GroupeUtilisateurOptions: options,
      UtilisateurOptions: UtilisateurOptions,
      datePickerCreation: Utils.uuidv4(),
      datePickerIntervention: Utils.uuidv4()
    }
  }

  searchDossier = async (data, name) => {
    const search = this.state.search

    if (name === 'sclasseur_id') {
      if (data) {
        search.classeur_id = data
      } else {
        const classeurInfo = Data.get(Constants.module.SDD, Constants.donnee.classeur, {
          id: search.classeur_id
        })
        if (classeurInfo && classeurInfo.classeur_id !== null) {
          search.classeur_id = classeurInfo.classeur_id
        }
      }
    } else {
      search[name] = data
    }

    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(search))
  }

  render() {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
        alignItems={'stretch'}
        alignContent={'flex-start'}
        direction={'column'}>
        <Input title={EurestoI18n.t('crm:#Ticket')}
          name="sdd_action.dossier_id"
          onChange={this.searchDossier}
          value={this.state.search['sdd_action.dossier_id']} />
        <DataComponent
          htmlOptions={(data) =>
            <Grid container alignItems={'center'} justify={'center'}>
              <Emoji emoji={data.icon} size={16} />&nbsp;
              {data.libelle}
            </Grid>}
          title={EurestoI18n.t('crm:Flags')}
          name="flag_id"
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.searchDossier}
          data={this.state.search.flag_id}
          object={Constants.donnee.flag}
          module={Constants.module.SDD}
        />
        <DatePicker value={this.state.search['|date_intervention']}
          range
          id={this.state.datePickerIntervention}
          title={EurestoI18n.t('commun:Date D\'intervention')}
          onChange={this.searchDossier}
          name={'|date_intervention'} />
        <ListingModal
          hideHeader
          style={{
            //height: User.CalculHeight.getHeightWanted(300),
            maxHeight: User.CalculHeight.getHeightWanted(300)
          }}
          title={EurestoI18n.t('crm:Assignée à')}
          data={this.state.GroupeUtilisateurOptions}
          onClick={this.searchDossier}
          name={'user_assign_id'}
          value={this.state.search.user_assign_id}
          libelle={this.state.search.user_assign_id && (this.state.GroupeUtilisateurOptions.find(g => g.value === this.state.search.user_assign_id) || {}).label} />
        <ListingModal
          hideHeader
          style={{
            //height: User.CalculHeight.getHeightWanted(300),
            maxHeight: User.CalculHeight.getHeightWanted(300)
          }}
          title={EurestoI18n.t('crm:Créée par')}
          data={this.state.UtilisateurOptions}
          onClick={this.searchDossier}
          name={'user_id'}
          value={this.state.search.user_id}
          libelle={this.state.search.user_id && (this.state.UtilisateurOptions.find(g => g.value === this.state.search.user_id) || {}).label} />

        <InputClient contact_id={this.state.search.contact_id} onChange={this.searchDossier} />
        <DataComponent
          title={EurestoI18n.t('Classeur')}
          onChange={this.searchDossier}
          type={Constants.typeSaisie.ComboMulti}
          subDataOption={true}
          dataMere={'classeur_id'}
          data={this.state.search.classeur_id}
          name="classeur_id"
          object={Constants.donnee.classeur}
          module={Constants.module.SDD} />
        <DatePicker value={this.state.search['|date_modification']}
          range
          id={this.state.datePickerCreation}
          disableFuture
          title={EurestoI18n.t('commun:Date Création')}
          onChange={this.searchDossier}
          name={'|date_modification'} />

        <Input title={EurestoI18n.t('crm:Objet Ticket')}
          name="sdd_dossier.libelle"
          onChange={this.searchDossier}
          value={this.state.search['sdd_dossier.libelle']} />
        <Input title={EurestoI18n.t('crm:Message')}
          name="message"
          onChange={this.searchDossier}
          value={this.state.search['message']} />
        <Multiple title={EurestoI18n.t('crm:Demande Traitée')} name="etat"
          autoComplete={false}
          style={{ paddingBottom: 0 }}
          onChange={this.searchDossier}
          value={this.state.search.etat}
          options={[{
            value: 1,
            label: 'Oui'
          }, {
            value: 0,
            label: 'Non'
          }]} />
        <Select title={EurestoI18n.t('crm:Fermé')} name="?actif"
          autoComplete={false}
          onChange={this.searchDossier}
          value={this.state.search['?actif']}
          options={[{
            value: -1,
            label: 'Oui'
          }, {
            value: 1,
            label: 'Non'
          }]} />
        <Select title={EurestoI18n.t('crm:Regrouper')} name="[[group_by]]"
          autoComplete={false}
          onChange={this.searchDossier}
          value={this.state.search['[[group_by]]']}
          options={[{
            value: "sdd_action.contact_id,sdd_action.classeur_id,sdd_action.dossier_id",
            label: 'Ticket/Dossier/Classeur'
          }, {
            value: "sdd_action.id",
            label: 'Non'
          }]} />
      </Grid>
    )
  }

}

export default DatagridContact



// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/Search/index.js